import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import _ from 'lodash';

import {
  IPaymentEventsSelector,
  IReceiptsSelector,
  ITeamsSelector,
} from 'app/types/selector';
import * as paymentEventsActions from 'app/ducks/paymentEvents/actions';
import * as teamPaymentRequestsActions from 'app/ducks/teamPaymentRequests/actions';
import * as receiptActions from 'app/ducks/receipts/actions';
import * as matchPaymentActions from 'app/ducks/matchPayments/actions';

import * as loadingSelectors from 'app/ducks/loading/selectors';
import * as paymentEventsSelectors from 'app/ducks/paymentEvents/selectors';
import * as receiptsSelectors from 'app/ducks/receipts/selectors';
import * as teamPaymentRequestsSelectors from 'app/ducks/teamPaymentRequests/selectors';
import * as teamsSelectors from 'app/ducks/teams/selectors';
import { ITeamPaymentRequestsSelector } from 'app/ducks/teamPaymentRequests/types';
import ReceiptComponent from './ReceiptComponent';

function selector(state): any {
  return {
    appReady: loadingSelectors.appReady(state),
    paymentEvents: paymentEventsSelectors.getPaymentEvents(state),
    teamPaymentRequests: teamPaymentRequestsSelectors.getTeamPaymentRequests(state),
    receipts: receiptsSelectors.getReceipts(state),
    teams: teamsSelectors.getTeams(state),
    isLoading: state.payments.isLoading,
    errors: { ...state.paymentEvents.backendErrors },
  };
}

const actionCreators = _.merge(receiptActions, paymentEventsActions, teamPaymentRequestsActions, matchPaymentActions);

interface IReceiptProps {
  appReady: any;
  receipts: IReceiptsSelector;
  teams: ITeamsSelector;
  teamPaymentRequests: ITeamPaymentRequestsSelector;
  paymentEvents: IPaymentEventsSelector;
  match: any;
  actions: any;
  isLoading: boolean;
  errors: any;
}

@(connect(selector, (dispatch) => ({
  actions: bindActionCreators(actionCreators, dispatch),
})) as any)
export default class Receipt extends React.Component<IReceiptProps, {}> {
  static defaultProps: IReceiptProps = {
    paymentEvents: {},
    receipts: {},
    teams: {},
    match: undefined,
    actions: undefined,
    isLoading: false,
    appReady: false,
    errors: {},
  };

  componentDidMount = () => {
    if (this.props.match.params.matchPaymentId) {
      this.props.actions.getReceipt(
        { id: this.props.match.params.matchPaymentId, receiptType: 'match-payments' },
      );
    } else if (this.props.match.params.forfeitId) {
      this.props.actions.getReceipt(
        { id: this.props.match.params.forfeitId, receiptType: 'forfeits' },
      );
    } else if (this.props.match.params.bulkMatchPaymentId) {
      this.props.actions.getReceipt(
        { id: this.props.match.params.bulkMatchPaymentId, receiptType: 'bulk-match-payments' },
      );
    }
  };

  componentDidUpdate = (prevProps) => {
    if (this.props.receipts.currentReceipt?.contextType !== 'bulk-match'
      && this.props.receipts.currentReceipt?.id !== null
      && prevProps.receipts.currentReceiptId !== this.props.receipts.currentReceiptId
      && !_.isEmpty(this.props.receipts.currentReceipt.fixtureMatch)) {
      const receipt = this.props.receipts.currentReceipt;
      const { fixtureMatch } = receipt;

      const returnIds = [];
      if (_.includes(receipt.group?.id, fixtureMatch?.groupOne?.id)) {
        returnIds.push(fixtureMatch.groupOneMatchPayment.id);
        returnIds.push(fixtureMatch.groupOneForfeit.id);
      }
      if (_.includes(receipt.group?.id, fixtureMatch?.groupTwo?.id)) {
        returnIds.push(fixtureMatch.groupTwoMatchPayment.id);
        returnIds.push(fixtureMatch.groupTwoForfeit.id);
      }
      this.props.actions.getAllTeamPaymentRequests(
        {
          filter: {
            'match-payment-forfeit-id': returnIds.join(','),
          },
          page: {
            size: 200,
          },
        },
        false,
      );
    }
  }

  render(): React.ReactNode {
    const receipt = this.props.receipts.currentReceipt;
    const { fixtureMatch } = receipt;
    // const receiptType = _.includes(this.props.match.path, 'forfeit') ? 'forfeit' : 'match';

    if (!_.isEmpty(receipt) && !_.isEmpty(fixtureMatch)) {
      return (
        <ReceiptComponent
          {...receipt}
          matchCardData={paymentEventsSelectors.getPaymentEventForMatchCard(
            fixtureMatch,
            receipt.group.id,
          )}
          createMatchPayment={this.props.actions.createMatchPayment}
          teamPaymentRequest={_.find(this.props.teamPaymentRequests.teamPaymentRequestsById, (p) => (!_.isEmpty(p.matchPayment) && p.matchPayment?.id === receipt.matchPayment?.id) || (!_.isEmpty(p.forfeit) && p.forfeit?.id === receipt.forfeit?.id))}
        />
      );
    }
    return null;
  }
}
